import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import "../invoice/invoice.css";
import Logo from "../../assests/papalogo.png";
import invoicefooter from "../../assests/invoicefooter.jpeg";
import phoneinvoice from "../../assests/call_invoice.png";
import emailinvoice from "../../assests/email_invoice.jpg";
import websiteinvoice from "../../assests/website_invoice.png";
import { Card, Form, notification, Switch, DatePicker, Button } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../config/api";
import { GET, PUT } from "../../utils/apicalls";
import moment from "moment";
import PageHeader from "../../admin/pageHeader/pageheader";


const UpdateInvoiceHr = () => {

  const navigate = useNavigate();
  const { id } = useParams();
  const [form] = Form.useForm();
  // State variables
  const [isLoading, setIsLoading] = useState(false);
  const [includeGST, setIncludeGST] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const [invoiceDetails, setInvoiceDetails] = useState({
    billNumber: "",
    date: moment().format("YYYY-MM-DD"),
    customerName: "",
    customerAddress: "",
    total: 0,
    discount: 0,
    gst: 0,
    finalAmount: 0,
    paymentMethod: "",
    customerGSTNumber: "",

  });

  const [items, setItems] = useState([
    {
      description: "",
      HSNSAC: "",
      quantity: 1,
      price: 0,
      subtotal: 0,
    },
  ]);

  // Fetch invoice data when component mounts
  useEffect(() => {
    getInvoiceData();
  }, [id]);


  const getInvoiceData = async () => {
    try {
      const api = `${API.GET_ONE_INVOICE}${id}`;
      const response: any = await GET(api, {});

      // Enhanced error handling
      if (!response || !response.data) {
        throw new Error("No invoice data received");
      }

      const invoiceData = response.data;

      // Ensure arrays are always converted properly
      const ensureArray = (value: any) => {
        if (value === undefined || value === null) return [];
        return Array.isArray(value) ? value : [value];
      };

      // Parse description as an array
      const descriptionArray = ensureArray(invoiceData.description);
      const HSNSAC = ensureArray(invoiceData.HSNSAC);
      const priceArray = ensureArray(invoiceData.subTotal);
      const quantityArray = ensureArray(invoiceData.quantity).length > 0
        ? ensureArray(invoiceData.quantity)
        : priceArray.map(() => 1); // Default to 1 if not provided
      const subtotalArray = ensureArray(invoiceData.subTotal);

      // Convert GST value to a number explicitly
      const gstValue = invoiceData.GST ? Number(invoiceData.GST) : 0;

      // Set GST toggle based on numerical value
      const shouldIncludeGst = gstValue > 0;
      setIncludeGST(shouldIncludeGst);

      // Set invoice details state
      setInvoiceDetails({
        billNumber: invoiceData.billNumber || "",
        date: invoiceData.billDate
          ? moment(invoiceData.billDate).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        customerName: invoiceData.customerName || "",
        customerAddress: invoiceData.customerAddress || "",
        total: subtotalArray.reduce((sum: number, val: number) => sum + Number(val), 0),
        discount: Number(invoiceData.discount) || 0,
        gst: gstValue,
        finalAmount: Number(invoiceData.finalAmount) || 0,
        paymentMethod: invoiceData.paymentMethod || "",
        customerGSTNumber: invoiceData.customerGSTNumber || "",
      });

      // Create items array
      const itemsArray = priceArray.map((price, index) => ({
        description: descriptionArray[index] || "",
        HSNSAC: HSNSAC[index] || "",
        quantity: quantityArray[index] || 1,
        price: Number(price) || 0,
        subtotal: subtotalArray[index] || (Number(price) * (quantityArray[index] || 1)),
      }));

      // Ensure at least one item exists
      setItems(itemsArray.length > 0 ? itemsArray : [{ description: "", HSNSAC: "", quantity: 1, price: 0, subtotal: 0 }]);

      // Populate form fields
      form.setFieldsValue({
        billNumber: invoiceData.billNumber || "",
        billDate: invoiceData.billDate ? moment(invoiceData.billDate) : moment(),
        customerName: invoiceData.customerName || "",
        customerAddress: invoiceData.customerAddress || "",
        paymentMethod: invoiceData.paymentMethod || "",
        finalAmount: invoiceData.finalAmount || "",
        customerGSTNumber: invoiceData.customerGSTNumber || "",
        description: descriptionArray,
        quantity: quantityArray,
        price: priceArray,
        subtotal: subtotalArray,
      });

      // Manually recalculate totals to ensure GST is properly applied if needed
      setTimeout(() => {
        recalculateTotals(itemsArray, Number(invoiceData.discount) || 0, shouldIncludeGst);
      }, 100);

    } catch (error) {
      console.error("Error fetching invoice data:", error);

      // More informative error notification
      notification.error({
        message: "Failed to Fetch Invoice Details",
        description: error instanceof Error ? error.message : "An unknown error occurred",
        duration: 5, // Show for 5 seconds
      });
    }
  };
  const submitHandler = async (values: any) => {
    try {
      setIsLoading(true);

      // Calculate subtotals for each item
      const subtotals = items.map(item => Number(item.subtotal));

      // Prepare invoice data with proper array format
      const invoiceData = {
        billNumber: invoiceDetails.billNumber,
        billDate: moment(invoiceDetails.date).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        customerName: invoiceDetails.customerName,
        customerAddress: invoiceDetails.customerAddress,
        discount: Number(invoiceDetails.discount),
        subTotal: subtotals, // Send as array
        finalAmount: Number(invoiceDetails.finalAmount),
        GST: includeGST ? String(invoiceDetails.gst) : "0",
        customerGSTNumber: invoiceDetails.customerGSTNumber || "",
        paymentMethod: invoiceDetails.paymentMethod || "",
        price: items.map(item => Number(item.price)),
        quantity: items.map(item => Number(item.quantity)),
        description: items.map(item => String(item.description)), // Ensure it's an array of strings
        HSNSAC: items.map(item => String(item.HSNSAC)), // Ensure it's an array of strings
      };

      // Update Invoice API Call
      const api = `${API.UPDATE_INVOICE}${id}`;
      const response = await PUT(api, invoiceData);

      notification.success({ message: "Invoice updated successfully!" });

      // Handle PDF Download
      if (isDownloading) {
        await generatePDF();
      }

      navigate(-1);
    } catch (error) {
      console.error("Update Error:", error);
      notification.error({ message: "Something went wrong! Please try again later." });
    } finally {
      setIsLoading(false);
    }
  };

  const handleItemChange = (index: any, field: any, value: any) => {
    const newItems = [...items];
    const item: any = newItems[index];

    if (item) {
      item[field] = value;

      // Recalculate subtotal
      if (field === "quantity" || field === "price") {
        item.subtotal = item.quantity * item.price;
      }

      setItems(newItems);

      // Update total and final total
      recalculateTotals(newItems);
    }
  };

  const addItem = (e: any) => {
    e.preventDefault(); // Prevent form submission
    setItems([
      ...items,
      {
        description: "",
        HSNSAC: "",
        quantity: 1,
        price: 0,
        subtotal: 0,
      },
    ]);
  };

  const removeItem = (index: any) => {
    if (items.length > 1) {
      const updatedItems = items.filter((_, idx) => idx !== index);
      setItems(updatedItems);
      recalculateTotals(updatedItems);
    } else {
      notification.info({
        message: "At least one item is required"
      });
    }
  };

  const handleGSTToggle = (checked: any) => {
    setIncludeGST(checked);
    recalculateTotals(items, invoiceDetails.discount, checked);
  };
  const handleDiscountChange = (value: any) => {
    const discount = Number(value) || 0; // treat as percentage
    setInvoiceDetails((prev) => ({
      ...prev,
      discount,
    }));
    recalculateTotals(items, discount, includeGST);
  };

  const recalculateTotals = (
    itemsList = items,
    discount = invoiceDetails.discount,
    gstEnabled = includeGST
  ) => {
    const total = itemsList.reduce((sum, item) => sum + Number(item.subtotal), 0); // Subtotal
    const discountAmount = parseFloat(((total * discount) / 100).toFixed(2)); // % discount on subtotal
    const discountedTotal = Math.max(0, total - discountAmount);
    const gst = gstEnabled ? parseFloat((discountedTotal * 0.18).toFixed(2)) : 0;
    const finalAmount = discountedTotal + gst;

    setInvoiceDetails((prev) => ({
      ...prev,
      total, // this is the subtotal
      gst,
      finalAmount,
    }));
  };


  const generatePDF = async () => {
    try {
      setIsDownloading(true);

      // Add a class to the body or container when downloading
      document.body.classList.add('hide-add-item');

      // Hide elements that shouldn't appear in the PDF
      const actionColumns = document.querySelectorAll(".actions-column");
      const buttons = document.querySelectorAll(".button-section, .add-item-section");

      actionColumns.forEach(col => col.classList.add("hidden-while-downloading"));
      buttons.forEach(btn => btn.classList.add("hidden-while-downloading"));

      const invoiceElement = document.getElementById("invoice-preview");
      if (!invoiceElement) throw new Error("Invoice preview element not found");

      // Add PDF-specific styling
      invoiceElement.classList.add("downloading-pdf");

      // Set specific dimensions to match A4 size (210mm × 297mm)
      const pdfWidth = 210; // A4 width in mm
      const pdfHeight = 297; // A4 height in mm

      // Calculate optimal sizing
      const html2canvasOptions = {
        scale: 1, // Higher scale for better quality
        useCORS: true,
        logging: false,
        width: invoiceElement.offsetWidth,
        height: invoiceElement.offsetHeight,
        windowWidth: invoiceElement.scrollWidth,
        windowHeight: invoiceElement.scrollHeight
      };

      const canvas = await html2canvas(invoiceElement, html2canvasOptions);

      // Create PDF with A4 dimensions
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      // Calculate proper scaling to fit content on A4
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      // Handle multi-page if content is taller than A4 height
      if (imgHeight > pdfHeight) {
        // Calculate how many pages we need
        const pageCount = Math.ceil(imgHeight / pdfHeight);

        // for (let i = 0; i < pageCount; i++) {
        //   // For pages after the first page, add a new page
        //   if (i > 0) {
        //     pdf.addPage();
        //   }

        // Calculate position to slice the canvas for current page
        // const sourceY = i * canvas.height / pageCount;
        const sourceHeight = canvas.height / pageCount;

        // Add sliced portion of the image to the current page
        pdf.addImage(
          canvas.toDataURL('image/png'),
          'PNG',
          0,
          0,
          pdfWidth,
          pdfHeight,
          '',
          'FAST',
          // i * -pdfHeight // Offset to show correct portion
        );
      }
      else {
        // If content fits on one page, simply add the image
        pdf.addImage(
          canvas.toDataURL('image/png'),
          'PNG',
          0,
          0,
          imgWidth,
          imgHeight
        );
      }

      // Save the PDF with a custom name
      pdf.save(`invoice_${invoiceDetails.billNumber}.pdf`);

    } catch (error) {
      console.error("PDF generation error:", error);
      notification.error({
        message: "Failed to generate PDF"
      });
    } finally {
      // Clean up - remove temporary classes
      document.body.classList.remove('hide-add-item');

      const invoiceElement = document.getElementById("invoice-preview");
      if (invoiceElement) {
        invoiceElement.classList.remove("downloading-pdf");
      }

      // Restore visibility of hidden elements
      const actionColumns = document.querySelectorAll(".actions-column");
      const buttons = document.querySelectorAll(".button-section, .add-item-section");

      actionColumns.forEach(col => col.classList.remove("hidden-while-downloading"));
      buttons.forEach(btn => btn.classList.remove("hidden-while-downloading"));

      setIsDownloading(false);
    }
  };

  const [lastbillNumber, setLastbillNumber] = useState("");

  // 1. Get current financial year
  const getCurrentFinancialYear = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    return month >= 4
      ? `${year}-${(year + 1).toString().slice(-2)}`
      : `${year - 1}-${year.toString().slice(-2)}`;
  };

  // 2. Fetch last bill number from backend
  useEffect(() => {
    const fetchLastBill = async () => {
      try {
        const res = await fetch("/api/invoices/last-bill");
        const data = await res.json();
        setLastbillNumber(data.lastbillNumber); // e.g., "2025-26/002"
      } catch (error) {
        console.error("Failed to fetch last bill number", error);
      }
    };
    fetchLastBill();
  }, []);

  // 3. Generate new bill number once we have the last one
  useEffect(() => {
    if (!lastbillNumber) return;

    const financialYear = getCurrentFinancialYear();
    const lastNumber = lastbillNumber.split("/")[1] || "000";
    const newNumber = String(parseInt(lastNumber, 10) + 1).padStart(3, "0");

    setInvoiceDetails((prev) => ({
      ...prev,
      billNo: `${financialYear}/${newNumber}`,
    }));
  }, [lastbillNumber]);
  return (
    <div className="invoice-container">
      <PageHeader title="Invoice Generator"></PageHeader>
      <Card>
        <Form
          form={form}
          onFinish={submitHandler}
          onValuesChange={(_, values) => {
            // Only update on form field changes, not button clicks
            setInvoiceDetails((prev) => ({
              ...prev,
              ...values,
            }));
          }}
        >
          <h2>Invoice Generator</h2>

          {/* Form Section */}
          <div className="form-section">
            <Form.Item
              name="billNumber"
              label="Bill No"
              rules={[{ required: true, message: "Bill number is required" }]}
            >
              <input
                type="text"
                value={invoiceDetails.billNumber}
                onChange={(e: any) =>
                  setInvoiceDetails((prev) => ({
                    ...prev,
                    billNumber: e.target.value,
                  }))
                }
              />
            </Form.Item>

            <Form.Item
              name="billDate"
              label="Bill Date"
              rules={[{ required: true, message: "Please select bill date" }]}
            >
              <DatePicker
                format="YYYY-MM-DD"
                style={{ width: "100%" }}
                onChange={(billDate: Date) => {
                  setInvoiceDetails((prev) => ({
                    ...prev,
                    date: billDate ? moment(billDate).format("YYYY-MM-DD") : "",
                  }));
                }}
              />
            </Form.Item>

            <Form.Item
              name="customerName"
              label="Customer Name"
              rules={[{ required: true, message: "Customer name is required" }]}
            >
              <input
                type="text"
                value={invoiceDetails.customerName}
                onChange={(e) => {
                  setInvoiceDetails((prev) => ({
                    ...prev,
                    customerName: e.target.value,
                  }));
                }}
              />
            </Form.Item>

            <Form.Item
              name="customerAddress"
              label="Customer Address"
              rules={[{ required: true, message: "Customer address is required" }]}
            >
              <textarea
                value={invoiceDetails.customerAddress}
                onChange={(e) => {
                  setInvoiceDetails((prev) => ({
                    ...prev,
                    customerAddress: e.target.value,
                  }));
                }}
              />
            </Form.Item>

            <Form.Item
              name="customerGSTNumber"
              label="Customer GST Number"
            >
              <input
                type="text"
                value={invoiceDetails.customerGSTNumber}
                onChange={(e) => {
                  setInvoiceDetails((prev) => ({
                    ...prev,
                    customerGSTNumber: e.target.value,
                  }));
                }}
              />
            </Form.Item>

            <Form.Item
              name="paymentMethod"
              label="Payment Method"
            >
              <input
                type="text"
                value={invoiceDetails.paymentMethod}
                onChange={(e) => {
                  setInvoiceDetails((prev) => ({
                    ...prev,
                    paymentMethod: e.target.value,
                  }));
                }}
              />
            </Form.Item>
          </div>

          <div className="togglesss">
            {/* GST Toggle */}
            <div className="gst-toggle">
              <label>Include GST:</label>
              <Switch checked={includeGST} onChange={handleGSTToggle} />
            </div>

            {/* Discount Section */}
            <div className="discount-section">
              <label>Discount:</label>
              <input
                type="number"
                value={invoiceDetails.discount}
                onChange={(e) => handleDiscountChange(e.target.value)}
              />
            </div>

            {/* Hide the "Add Item" button during download */}
            <div className="add-item-section">
              {!isDownloading && (
                <Button
                  type="default"
                  onClick={addItem}
                  style={{ marginBottom: "10px" }}
                >
                  Add Item
                </Button>
              )}
            </div>
          </div>
          {/* Invoice Preview */}
          <Card style={{ margin: "0px", marginRight: "0px" }}>
            <div id="invoice-preview" className="invoice-preview">
              <div>
                <img
                  src={invoicefooter}
                  style={{ width: "100%" }}
                  alt="Invoice Footer"
                />

              </div>

              <div className="invoice-header">
                <div className="logo-container">
                  <img src={Logo} alt="Company Logo" className="company-logo" />
                  {includeGST && <h5><b>Tax Invoice</b></h5>}
                </div>

                <div>
                  <div className="payment-row">
                    <span className="label">{!includeGST && <h3>Estimated Invoice</h3>}
                      {includeGST && <h3>Invoice</h3>}</span>
                  </div>
                  <div className="payment-row">
                    <span className="label">Bill No  </span>
                    <span className="colon">:</span>
                    <span className="value">  {includeGST && <span>2024-25/</span>}   {invoiceDetails.billNumber}</span>
                  </div>
                  <div className="payment-row">
                    <span className="label">Date</span>
                    <span className="colon">:</span>
                    <span className="value">
                      {new Date(invoiceDetails.date).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                      })}
                    </span>
                  </div>
                  <div className="payment-row">
                    {includeGST && <div className="payment-row"><span className="label">POS</span><span className="colon">:</span><span className="value">KERALA (32) </span></div>}
                  </div>
                </div>
              </div>

              <div
                className="two"
                style={{
                  width: "300px",
                  wordWrap: "break-word",
                  overflow: "hidden",
                  textAlign: "left",
                }}
              >
                <p>   <b>Bill To:</b></p>
                <p> {invoiceDetails.customerName}
                  <p>{invoiceDetails.customerAddress}</p>
                  {includeGST && invoiceDetails.customerGSTNumber && (
                    <p>GST Number: {invoiceDetails.customerGSTNumber}</p>
                  )}
                </p>
              </div>

              <div className="one">
                <div className="two">
                  <p>
                    <b> Company Address:</b>
                    <br />
                    PAPA DIGITAL SOLUTION <br />
                    Blue Hill Tower , 3rd Floor
                    <br />
                    Kuzhikkatumoola,Kakkanad-kochi
                    <br />
                    682030 Kerala,INDIA
                  </p>
                  <p>
                    {includeGST && <strong>GST_Number:-32ATAPR8197G1ZE </strong>}
                  </p>
                </div>

                {includeGST && (
                  <div className="payment-container">
                    <h4 className="payment-header">PAYMENT METHOD</h4>
                    <div className="payment-details">
                      <div className="payment-row">
                        <span className="label">GPAY</span>
                        <span className="colon">:</span>
                        <span className="value">977 83 63 852</span>
                      </div>
                      <div className="payment-row">
                        <span className="label">Account No</span>
                        <span className="colon">:</span>
                        <span className="value">2152202100000261</span>
                      </div>
                      <div className="payment-row">
                        <span className="label">IFC Code</span>
                        <span className="colon">:</span>
                        <span className="value">PUNB0215220</span>
                      </div>
                      <div className="payment-row">
                        <span className="label">Account Name</span>
                        <span className="colon">:</span>
                        <span className="value">PAPA DIGITAL SOLUTION</span>
                      </div>
                      <div className="payment-row">
                        <span className="label">Bank Name</span>
                        <span className="colon">:</span>
                        <span className="value">PUNJAB NATIONAL BANK</span>
                      </div>
                      <div className="payment-row">
                        <span className="label">Branch Name</span>
                        <span className="colon">:</span>
                        <span className="value">KAKKANAD,KUSUMAGIRI</span>
                      </div>
                    </div>
                  </div>
                )}

                {!includeGST && (
                  <div className="payment-container">
                    <h4 className="payment-header">PAYMENT METHOD</h4>
                    <div className="payment-details">
                      <div className="payment-row">


                        <span className="label">GPAY</span>
                        <span className="colon">:</span>
                        <span className="value">977 83 63 852</span>

                      </div>
                      <div className="payment-row">
                        <span className="label">  Account No</span>
                        <span className="colon">:</span>
                        <span className="value"> 42191757548</span>
                      </div>
                      <div className="payment-row">
                        <span className="label">  IFC Code</span>
                        <span className="colon">:</span>
                        <span className="value"> SBIN0070425</span>
                      </div>
                      <div className="payment-row">
                        <span className="label">  Account Name </span>
                        <span className="colon">:</span>
                        <span className="value"> Farhana K N</span>
                      </div>
                      <div className="payment-row">
                        <span className="label">  Bank Name </span>
                        <span className="colon">:</span>
                        <span className="value"> SBI</span>
                      </div>
                      <div className="payment-row">
                        <span className="label">   Branch Name</span>
                        <span className="colon">:</span>
                        <span className="value"> Kizhakamabalam</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* Table Section */}
              <Card>
                <table className="invoice-table">
                  <thead>
                    <tr>
                      <th>Description</th>
                      {includeGST && <th>HSN/SAC</th>}
                      <th>Quantity</th>
                      <th>Price</th>
                      <th>Subtotal</th>
                      {!isDownloading && (
                        <th className="actions-column">Actions</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {isDownloading ? (
                            <div
                              style={{
                                minHeight: '40px',
                                width: '100%',
                                whiteSpace: 'pre-wrap',
                                wordWrap: 'break-word',
                                border: '1px solid #ccc',
                                padding: '4px'
                              }}
                            >
                              {item.description}
                            </div>
                          ) : (
                            <textarea
                              value={item.description}
                              onChange={(e) =>
                                handleItemChange(index, 'description', e.target.value)
                              }
                              style={{ height: 'auto', minHeight: '40px', width: '100%' }}
                              rows={Math.max(1, (item.description.match(/\n/g) || []).length + 1)}
                            />
                          )}
                        </td>
                        {includeGST &&
                          <td>
                            <input
                              type="text"
                              value={item.HSNSAC || "998361"} // Added default value of "123"
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "HSNSAC",
                                  e.target.value
                                )
                              }
                              style={{ height: "30px", width: "100%" }}
                            />
                          </td>
                        }
                        <td>
                          <input
                            name="quantity"
                            type="number"
                            min="1"
                            value={item.quantity}
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "quantity",
                                Number(e.target.value)
                              )
                            }
                            style={{ height: "30px", width: "100%" }}
                          />
                        </td>
                        <td>
                          <input
                            name="price"
                            type="number"
                            min="0"
                            value={item.price}
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "price",
                                Number(e.target.value)
                              )
                            }
                            style={{ height: "30px", width: "100%" }}
                          />
                        </td>
                        <td>₹{item.subtotal.toFixed(2)}</td>
                        {!isDownloading && (
                          <td className="actions-column">
                            <button
                              type="button"
                              onClick={() => removeItem(index)}
                              className="remove-btn"
                            >
                              Remove
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Card>
              <div style={{ paddingTop: "200px" }}></div>
              <hr color="red"></hr>
              <div className="main">
                <div className="main1">
                  <h3>TERMS AND CONDITIONS</h3>
                  <p>
                    This quotation will be valid for 30 days.
                    <br /> Payment is non-refundable once payment
                    <br /> has been made and work has started
                    <br />
                    {includeGST && (
                      <>
                        <p>1. Payment to be made by crossed DD/Cheque</p>
                        <p>
                          2. Every legal matter relating to this transaction
                          shall
                          <br />
                          come under the jurisdiction of Ernakulam courts
                        </p>
                        <p>
                          3. We declare that this invoice shows the actual price
                          <br />
                          and that all particulars are true and correct
                        </p>
                      </>
                    )}
                    {!includeGST && <b>GST NOT INCLUDED</b>}
                  </p>
                </div>

                <div className="main2">
                  <div className="payment-row">
                    <span className="label"> {includeGST && <b>TAXABLE VALUE</b>} {!includeGST && <b>SubTotal Total</b>}</span>
                    <span className="colon">:</span>
                    <span className="value">₹{invoiceDetails.total.toFixed(2)}</span>
                  </div>
                  <div className="payment-row">
                    <span className="label">Discount (  {invoiceDetails.discount}%       )</span>
                    <span className="colon">:</span>
                    <span className="value">

                      ₹{((invoiceDetails.total * invoiceDetails.discount) / 100).toFixed(2)}
                    </span>
                  </div>


                  {includeGST && (
                    <>
                      <div className="payment-row">
                        <span className="label"> CGST (9%)</span>
                        <span className="colon">:</span>
                        <span className="value">   ₹
                          {(invoiceDetails.gst / 2).toFixed(2)}</span>
                      </div>
                      <div className="payment-row">
                        <span className="label">SGST (9%)</span>
                        <span className="colon">:</span>
                        <span className="value">   ₹
                          {(invoiceDetails.gst / 2).toFixed(2)}</span>
                      </div>
                      <p
                        style={{
                          backgroundColor: "#9e2118",
                          color: "white",
                          fontSize: "18px",
                        }}
                      >
                        <strong> Total:</strong> ₹
                        {invoiceDetails.finalAmount.toFixed(2)}
                      </p>
                    </>
                  )}

                  {!includeGST && (
                    <p
                      style={{
                        backgroundColor: "#9e2118",
                        color: "white",
                        fontSize: "18px",
                      }}
                    >
                      <strong>Final Total:</strong> ₹
                      {(invoiceDetails.total - invoiceDetails.discount).toFixed(2)}
                    </p>
                  )}

                  <hr />
                  <p>
                    FARHANA K N
                    <br /> ACCOUNTS MANAGER
                  </p>
                </div>
              </div>

              <div className="footer">
                <div style={{ paddingLeft: "40px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={phoneinvoice}
                      alt="Phone Icon"
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    <span>+91-956 21 21 117</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={emailinvoice}
                      alt="Email Icon"
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    <span>papaekmpapa@gmail.com</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={websiteinvoice}
                      alt="Website Icon"
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    <span>www.papadigitalsolution.com</span>
                  </div>
                </div>
                <p
                  style={{
                    textAlign: "center",
                    paddingTop: "0px",
                    fontSize: "20px",
                  }}
                >
                  <b>THANK YOU FOR YOUR BUSINESS</b>
                </p>
                <div>
                  <img
                    src={invoicefooter}
                    style={{ width: "100%", paddingTop: "43px" }}
                    alt="Invoice Footer"
                  />
                </div>
              </div>
            </div>
          </Card>
          <div
            className="button-section"
            style={{ marginTop: "20px", display: "flex", gap: "10px" }}
          >
            <Button
              type="primary"
              onClick={() => {
                setIsDownloading(false);
                form.submit();
              }}
              loading={isLoading}
            >
              Update Invoice
            </Button>
            <Button
              type="primary"
              onClick={() => {
                setIsDownloading(true);
                form.submit();
              }}
              loading={isLoading}
            >
              Update & Download
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default UpdateInvoiceHr;